<template>
    <v-snackbar
        v-if="warningZone"
        v-model="warningZone"
        :timeout="-1"
        :value="true"
        absolute
        centered
        color="light-blue accent-2"
        elevation="24"
        style="z-index:2000;"
    >
        It seems like you're inactive for a while.
    </v-snackbar>
</template>

<script>
import { mapActions } from "vuex";
import axios from "axios";
const url = require("../client_config/config").url;
const ACTIVITY_KEY = 'lastActivity';

export default {
    data() {
        return {
            events: ['click', 'mousemove', 'mousedown', 'touchstart', 'touchmove', 'touchend', 'scroll', 'keypress', 'load'],
            warningTimer: null,
            logoutTimer: null,
            warningZone: false,
        };
    },

    mounted() {
        this.events.forEach(function (event) {
            window.addEventListener(event, this.resetTimer)
        }, this);
        this.setTimers();

        window.addEventListener('storage', (event) => {
            if (event.key === ACTIVITY_KEY) {
                this.resetTimer();
            }
        });


    },

    destroyed() {
        this.events.forEach(function (event) {
            window.removeEventListener(event, this.resetTimer);
        }, this);

        this.resetTimer();
    },

    methods: {
        ...mapActions(["logout"]),

        setTimers() {
            let currentPage = this.$router.history.current.path;
            if (currentPage === '/') {
                // console.log("LOGIN FORM!");
            } else {
                this.warningTimer = setTimeout(this.warningMessage, 12 * 60 * 1000); //1 * 60 * 1000 - 14minutes
                this.logoutTimer = setTimeout(this.logoutUser, 15 * 60 * 1000);
            }
            this.warningZone = false;
        },

        warningMessage() {
            this.warningZone = true;
        },

        async logoutUser() {
            const response = await axios.post(`${url}/users/logout`);

            if (response.data.success) {
                await this.logout();
                window.location.href = "/";
            }
            //let currentPage = this.$router.history.current.fullPath;
            //localStorage.setItem('lastPage', currentPage);
            // localStorage.setItem('autoLogout', "auto");
            // this.logout();
            // window.location.href = "/";
        },

        resetTimer() {
            clearTimeout(this.warningTimer);
            clearTimeout(this.logoutTimer);
            this.updateActivity()
            this.setTimers();
        },

        updateActivity() {
            localStorage.setItem(ACTIVITY_KEY, Date.now().toString());
        },
    },


};
</script>
